import React from "react";
export default function PhysicalStorage({data}) {
  return (
    <>
      <section className="physical-storage-area">
        <div className="container">
          <div className="row">
            <div className="col-lg-7">
              <h3 className="heading">{data?.head}</h3>
              <p dangerouslySetInnerHTML={{__html:data?.desc}}/>
            </div>
  
            {   data?.boxes?.map((item,index)=>(
                <div key={index} className="col-lg-6 col-md-6">
              <div className="physical-storage-box">
                <img src={item?.img} alt="Icons"/>
                <span>{item?.label}</span>
              </div>
            </div>
              ))
            }

          </div>
        </div>
      </section>
    </>
  )
}